import { render, staticRenderFns } from "./ZoneModel.vue?vue&type=template&id=32b32eb9&"
import script from "./ZoneModel.vue?vue&type=script&lang=js&"
export * from "./ZoneModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports